import store from '@/store';

export default function guard(to, from, next) {
  if (
    (
      (store.state.logs.user_info === null)
      || (store.state.currentStep === null)
    ) && (to.name !== 'Registration')
  ) next({ name: 'Registration' });
  else
  if (
    (store.getters.getStepView !== to.name)
    && (store.getters.isLogsEmpty)
  ) {
    next({ name: store.getters.getStepView });
  } else
  if ((from.name === 'Exercise') && (to.name === 'Exercise')) {
    next({
      name: store.getters.getStepView,
      props: {
        id: store.state.currentExercise,
      },
    });
  } else next();
}
